{
  "greeting": "สวัสดีครับ/ค่ะ! วันนี้ให้ช่วยเรื่องไวน์อะไรดีคะ?",
  "thinking": "✨ กำลังคิด...",
  "thinkingStep": "✨ กำลังค้นหาไวน์ที่เหมาะกับคุณ…🍷",
  "askAboutWine": "เช่น บอร์โดซ์แดงยุค 1990 ประมาณ $1500 | เบอร์กันดีขาวระดับหมู่บ้าน ต่ำกว่า $600",
  "askAboutWineFirst": "ต้องการซื้อ (ภูมิภาค + สี + วินเทจ + งบประมาณ)",
  "waitingForResponse": "กำลังรอคำตอบ...",
  "dailyLimitReached": "คุณใช้สิทธิ์ที่ปรึกษาประจำวันครบแล้ว กรุณากลับมาหลัง 00:00 HKT เพื่อใช้งานต่อ",
  "chatHistory": "ประวัติการแชท",
  "noChatHistory": "ยังไม่มีประวัติการแชท",
  "startConversation": "เริ่มการสนทนาเพื่อดูที่นี่",
  "backToChat": "กลับไปที่แชท",
  "newChat": "แชทใหม่",
  "history": "ประวัติ",
  "search": "ค้นหา",
  "whatsapp": "WhatsApp",
  "wineAdvisor": "ที่ปรึกษาไวน์",
  "chat": "แชท",
  "chatNumber": "แชท {number}",
  "wineRecommended": "แนะนำไวน์ {count} รายการ",
  "winesRecommended": "แนะนำไวน์ {count} รายการ",
  "justNow": "เมื่อสักครู่",
  "minuteAgo": "{count} นาทีที่แล้ว",
  "minutesAgo": "{count} นาทีที่แล้ว",
  "hourAgo": "{count} ชั่วโมงที่แล้ว",
  "hoursAgo": "{count} ชั่วโมงที่แล้ว",
  "dayAgo": "{count} วันที่แล้ว",
  "daysAgo": "{count} วันที่แล้ว",
  "noMessagesYet": "ยังไม่มีข้อความ",
  "perBottle": "ต่อขวด",
  "priceNA": "ไม่ระบุราคา",
  "buyNow": "ซื้อเลย",
  "moreInformation": "ข้อมูลเพิ่มเติม",
  "share": {
    "button": "แชร์",
    "title": "แชร์บทสนทนา",
    "description": "แชร์บทสนทนานี้กับเพื่อนของคุณโดยใช้ลิงก์ด้านล่าง:",
    "generating": "กำลังสร้างลิงก์แชร์...",
    "error": "ไม่สามารถสร้างลิงก์แชร์ได้",
    "copy": "คัดลอก",
    "copied": "คัดลอกแล้ว!",
    "note": "หมายเหตุ: ลิงก์นี้จะหมดอายุใน 30 วัน เมื่อมีคนเปิดลิงก์นี้ พวกเขาจะเห็นสำเนาของบทสนทนานี้"
  },
  "checkOutWine": "ลองดูไวน์นี้: {name} {vintage}",
  "linkCopied": "คัดลอกลิงก์ไปยังคลิปบอร์ดแล้ว!",
  "contactWhatsApp": "ติดต่อเราผ่าน WhatsApp เพื่อดูตัวเลือกเพิ่มเติม",
  "errorLoadingWine": "ขออภัย ไม่สามารถโหลดรายละเอียดไวน์ได้",
  "errorOccurred": "เกิดข้อผิดพลาดในการดึงข้อมูลคำตอบ",
  "you": "คุณ",
  "welcome": {
    "intro": "ยินดีต้อนรับสู่ WWX ฉันคือ Zyra ที่ปรึกษาไวน์ AI ของคุณ คุณสามารถเข้าถึง:",
    "features": {
      "globalMarket": "ตลาดไวน์ชั้นดีทั่วโลก (ผู้ขาย UK, FR, HK)",
      "realTimeOffers": "ข้อเสนอที่ดีที่สุดแบบเรียลไทม์ภายในงบประมาณของคุณ",
      "personalized": "คำแนะนำที่ปรับแต่งเฉพาะสำหรับคุณ",
      "comparison": "เปรียบเทียบวินเทจและแบรนด์อย่างง่ายดาย",
      "instantCheckout": "สั่งซื้อจำนวนและจัดส่งทันที"
    },
    "question": "วันนี้ให้แนะนำอะไรดีคะ?",
    "trendingPrompts": "ตัวอย่างคำถาม",
    "promptExamples": {
      "title": "วิธีถาม:",
      "good": "✓ ตัวอย่างที่ดี:",
      "bad": "✗ หลีกเลี่ยงคำถามที่ไม่ระบุงบประมาณ:"
    },
    "prompts": {
      "bordeaux": "บอร์โดซ์แดง ประมาณ $800",
      "champagne": "แชมเปญ Grower ต่ำกว่า $2000",
      "firstGrowth": "ข้อเสนอที่ดีที่สุด first growth 2010-2019"
    }
  },
  "feedback": {
    "helpful": "มีประโยชน์",
    "notHelpful": "ไม่มีประโยชน์",
    "thankYou": "ขอบคุณสำหรับความคิดเห็น!",
    "whatDidYouLike": "คุณชอบอะไร?",
    "whatCouldBeImproved": "อะไรที่ควรปรับปรุง?",
    "category": "หมวดหมู่",
    "selectCategory": "เลือกหมวดหมู่",
    "categories": {
      "accuracy": "ความถูกต้อง",
      "helpfulness": "ความเป็นประโยชน์",
      "responseSpeed": "ความเร็วในการตอบ",
      "clarity": "ความชัดเจน",
      "other": "อื่นๆ"
    },
    "comments": "ความคิดเห็น",
    "placeholder": "บอกเราเพิ่มเติมเกี่ยวกับประสบการณ์ของคุณ...",
    "cancel": "ยกเลิก",
    "submit": "ส่งความคิดเห็น",
    "submitting": "กำลังส่ง..."
  },
  "auth": {
    "limitReached": "ถึงขีดจำกัดประจำวัน",
    "signUpToday": "สมัครเพื่อรับข้อความเพิ่มเติม",
    "limitMessage": "คุณใช้ข้อความถึงขีดจำกัดประจำวันแล้ว สมัครบัญชีฟรีเพื่อแชทต่อ",
    "benefitsMessage": "สร้างบัญชีฟรีเพื่อแชทต่อและบันทึกประวัติแชทในทุกอุปกรณ์",
    "remainingMessages": "คุณมีข้อความเหลือ {count} ข้อความวันนี้",
    "signUp": "สมัคร",
    "login": "เข้าสู่ระบบ",
    "loggedInAs": "เข้าสู่ระบบเป็น {email}",
    "logout": "ออกจากระบบ"
  }
}
